import React from "react";
import "./style.scss";
const AboutUsStats = () => {
	const StatsArray = [
		{
			topText: "300+",
			bottomText: "Homes",
		},
		{
			topText: "1000+",
			bottomText: "Rooms",
		},
		{
			topText: "200K+",
			bottomText: "Happy Families",
		},
		{
			topText: "65+",
			bottomText: "World-class NPS",
		},
		// {
		// 	topText: "80+",
		// 	bottomText: "Trusted Home Owners",
		// },
	];

	return (
		<div className="AboutUsStatsWrapper">
			{StatsArray.map((val) => {
				return (
					<StatsComponent topText={val.topText} bottomText={val.bottomText} />
				);
			})}
		</div>
	);
};

const StatsComponent = ({ topText, bottomText }: any) => {
	return (
		<div className="stats_component_wrapper">
			<div className="top_text">{topText}</div>
			<div className="bottom-text">{bottomText}</div>
		</div>
	);
};

export default AboutUsStats;
